import { Injectable, inject } from '@angular/core';
import { StateService } from 'src/app/core';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class FeatureFlagService {
	stateService = inject(StateService);
	localStorageService = inject(LocalStorageService);

	/**
	 * List of feature flags with the sole purpose to be used for Angie development.
	 */
	private readonly ANGIE_FLAGS: Record<string, { portalMetaKey?: string; defaultValue: boolean }> = {
		BULK_ACTIONS_V2: {
			portalMetaKey: 'bulk_actions_enabled',
			defaultValue: false
		}
	};

	isFeatureFlagEnabled(key: keyof typeof this.ANGIE_FLAGS): boolean {
		const isFlagEnabled =
			this.stateService.portalMeta[this.ANGIE_FLAGS[key].portalMetaKey] ?? this.ANGIE_FLAGS[key].defaultValue;

		if (environment.env === 'production') {
			return isFlagEnabled;
		}

		const overrideContent = this.localStorageService.getData(`ANGIE_FLAGS:${key}`);
		const overrideFlag = !!overrideContent ? overrideContent === 'true' : undefined;

		const isEnabled = Boolean(overrideFlag ?? isFlagEnabled);
		if (overrideFlag) {
			console.info(`%c[!] ANGIE_FLAGS:${key}=${isEnabled}`, 'color: yellow');
		}

		return isEnabled;
	}
}
